/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：566
 */

module.exports = {
  cancelBtn: "SaveProgress_cancelBtn__2SrYo",
  text: "SaveProgress_text__2QQM7",
  footer: "SaveProgress_footer__3R_fE",
  progress: "SaveProgress_progress__2UMMN",
  progressText: "SaveProgress_progressText__2RKkd",
  progressBg: "SaveProgress_progressBg__30ZX1",
  progressInner: "SaveProgress_progressInner__3CnxQ",
  main: "SaveProgress_main__lgYAm",
  container: "SaveProgress_container__1YkZ-"
}
